import { useResponsive } from "../../hooks/useResponsive.js";
import TrailerButton from "../ui/TrailerButton.js";

function VideoHighlight({
  video,
  onClick,
  showTrailer = false,
  onCloseTrailer,
  fullScreen = false,
}) {
  const { isSM } = useResponsive();

  const getEmbeddableUrl = (url) => {
    if (!url) return "";
    if (url.includes("youtube.com/watch?v=")) {
      const base = url.replace("watch?v=", "embed/");
      return base.includes("?")
        ? `${base}&autoplay=1`
        : `${base}?autoplay=1`;
    } else if (url.includes("vimeo.com/")) {
      const videoId = url.split("/").pop();
      return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }
    return url;
  };

  const containerClasses = fullScreen
    ? "relative w-full h-full overflow-hidden cursor-pointer"
    : "relative w-full h-[25rem] sm:h-[70vh] rounded-lg overflow-hidden cursor-pointer border-b border-red-500";

  const trailerWrapperClasses = fullScreen
    ? "w-full h-full relative"
    : "w-full h-full max-w-[90vw] max-h-[90vh] relative";

  const iframeClasses = fullScreen
    ? "w-full h-full"
    : "w-full h-full rounded-lg";

  return (
    <div className={containerClasses} onClick={onClick}>
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{ backgroundImage: `url(${video.image})` }}
      />
      <div className="absolute bottom-0 left-0 right-0 h-2/3 bg-gradient-to-t from-black/80 via-black/35 to-transparent z-10" />

      {showTrailer && (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/90">
          {onCloseTrailer && (
            <button
              onClick={(event) => {
                event.stopPropagation();
                onCloseTrailer();
              }}
              aria-label="Chiudi"
              className="absolute top-4 right-4 z-30 text-white text-3xl leading-none"
            >
              ✕
            </button>
          )}
          <div className={trailerWrapperClasses}>
            <iframe
              src={getEmbeddableUrl(video.trailerUrl)}
              title="Trailer"
              className={iframeClasses}
              frameBorder="0"
              // allowFullScreen
              allow="autoplay" // <-- importante per policy browser!
            />
          </div>
        </div>
      )}
    </div>
  );
}


export default VideoHighlight;
